import { ColoredAvatar } from "../../components/ColoredAvatar"
import { useGetUserQuery } from "../../services/resourceGroups/userApi";


const UserAvatar = (props: { userId: string, size?: any }) => {

    const { userId } = props;
    const { data: user } = useGetUserQuery(userId, { skip: !userId || userId === '00000000-0000-0000-0000-000000000000' });
    
    return (
        <ColoredAvatar username={user?.name} size={props.size ?? 'scale800'}overrides={{
            Initials: {
                style: ({ $theme }) => ({
                    fontSize: $theme.typography.ParagraphXSmall.fontSize
                })
            }
        }}></ColoredAvatar>
    )
}

export default UserAvatar;